import debug from 'debug';

import backend, { ROLES } from './backend';

const logger = debug('c3:launcher:auth');
const tokenKey = 'launcher::token';

const Auth = {
  user: null,
  envToolsConfig: {},
  environment: '',

  async setToken(token) {
    let currentToken = token;

    if (!currentToken) {
      currentToken = localStorage.getItem(tokenKey);
    }

    if (!currentToken) {
      return null;
    }

    try {
      const response = await backend.getWithHeader(ROLES, currentToken);

      localStorage.setItem(tokenKey, currentToken);
      this.environment = response.data.environment;
      this.user = response.data.user;
      this.envToolsConfig = response.data.envToolsConfig;

      return { user: response.data.user };
    } catch (e) {
      logger(e);

      return null;
    }
  },

  getEnvTools() {
    return this.envToolsConfig;
  },

  getUser() {
    return this.user;
  },

  getEnvText() {
    return this.environment;
  },

  getToken() {
    return localStorage.getItem(tokenKey);
  },

  removeToken() {
    localStorage.removeItem(tokenKey);
  },
};

export default Auth;
